import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import UserAddressService from "../../services/useraddress/useraddress.service";
import AreaSearch from './area-search';
import AreaDataTable from './area-datatable';
import { PincodeAreaModel } from "../../models/cust-address/cust-address-model";
import AppLoading from '../app-loading/app-loading';

const AddArea: React.FC = () => {
  const { t } = useTranslation();
  const [areaList, setAreaList] = useState<PincodeAreaModel[]>([]);  
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);  
  const [pageNumber, setPageNumber] = useState<number>(1);  
  const [pageSize, setPageSize] = useState<number>(10); 
  const [filter, setFilter] = useState<any>();
  const [searchTerm, setSearchTerm] = useState<any>();

  const reloadPage = (val: boolean) => {
    if (val) {
      fetchData(pageNumber, pageSize);
    }
  };

  const fetchData = async (pageNumber: any, pageSize: any) => {
    setLoading(false);
    try {
      const response = await UserAddressService.getAllPincodeArea(pageNumber, pageSize);
      await setAreaList(response.areas);  
      await setTotalRecords(response.totalRecords);  
    } catch (error) {
      console.error("Error fetching data:", error);
      setAreaList([]);  
    } 
  };

  const handlePageChange = async (event: any) => {
    setLoading(true);
    const newPageNumber = Math.floor(event.first / event.rows) + 1;
    setPageNumber(newPageNumber);
    setPageSize(event.rows);
    
    const response = await UserAddressService.searchFilterPincode(filter, searchTerm, newPageNumber, event.rows);
    await setAreaList(response.areas);
    await setTotalRecords(response.totalRecords);
    setLoading(false); 
  };

  return (
    <>
      <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
        <div className="col-12">
          <h5 className="ml-1 mb-0">{"View All Pincode/Area"}</h5>
        </div>

        <AreaSearch 
          reloadPage={reloadPage} 
          setLoading={setLoading} 
          setPageNumber={setPageNumber} 
          setPageSize={setPageSize}
          setAreaList={setAreaList} 
          setTotalRecords={setTotalRecords}
          setFilter={setFilter}
          setSearchTerm={setSearchTerm} 
        />

        <AreaDataTable 
          data={areaList} 
          NoofRecords={totalRecords} 
          pageNumber={pageNumber} 
          pageSize={pageSize} 
          filterBy={filter}
          searchTerm={searchTerm}
          onPageChange={handlePageChange} 
        />
      </div>
      
      {loading && <AppLoading />}
    </>
  );
};

export default AddArea;
